import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {faPencilAlt, faPlus} from '@fortawesome/free-solid-svg-icons';
import { UserManagementService } from 'src/app/admin/data-access/user-management.service';
import {MatSnackBar} from "@angular/material/snack-bar";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";


interface ConfigList {
  rostersource_id: number;
  active: boolean;
  createdate: string;
  last_updated: string;
  host: string;
  username: string;
}

@Component({
    selector: 'autoImportUsersConfigList',
    templateUrl: './autoImportUsersConfigList.html',
    styleUrls: ['./autoImportUsersConfigList.css'],
    standalone: false
})

export class AutoImportUsersConfigListComponent implements OnInit {
  constructor(private userService: UserManagementService, private router: Router, private _snackBar: MatSnackBar) {}

  faPencilAlt = faPencilAlt;
  configList: ConfigList[] = [];
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'User Management',
    route: 'dashboard/UserManagement'
  }, {
    text: 'Import Users',
    route: 'dashboard/UserManagement/AllUsers/ImportUsers'
  }]

  ngOnInit() {
    this.userService.getAutoRosterConfig().subscribe((response) => {
      if(response.success) {
        this.configList = response.result;
        this.configList.forEach((config) => {
          if (config.createdate !== null)
            config.createdate = new Date(config.createdate).toLocaleDateString();
          if (config.last_updated !== null)
            config.last_updated = new Date(config.last_updated).toLocaleDateString();
        })
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
      }
    })
  }

  create() {
    this.router.navigate(['dashboard/UserManagement/AllUsers/ImportUsers/AutomaticImport'])
  }

  edit(id: number) {
    this.router.navigate(['dashboard/UserManagement/AllUsers/ImportUsers/AutomaticImport'], {queryParams: {id}})
  }

  openExitDialog(navigate: string) {
    this.router.navigate([navigate])
  }

  protected readonly faPlus = faPlus;
}
